import React from 'react'
import { Modal, FormGroup, FormControl } from 'react-bootstrap'
import {rejectTask} from '../api'

export default React.createClass({
  getInitialState: function() {
    return {
        rejectionComment: ''
    }
  },
  sendUpdateToServer: function() {
    rejectTask(this.props.modalCard.mobileJob.jobId, this.state.rejectionComment, document.getElementById('rejectReason').value).then((response) => {
      if (response !== 'error') {
        this.props.openNotificationModal('decline-task-modal', "Declined Task!", "Your task has been declined. Updates will be reflected soon.")
        this.props.hide()
      } 
      else {
        this.props.openNotificationModal('decline-task-modal', "Processing Error", "There was an error processing your action. Please try again later.")
        this.props.hide()
        }
    })
  },
  handleInputChange: function (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({[name]: value})

  },
  returnModal: function() {
    this.props.hide()
    this.props.goBack(this.props.modalCard)
  },
  render: function () {
    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='upgrade-modal'>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6}}>
            <div className='text-center pull-down-xs-3'>
                <h2 className='text-center'>Decline Work</h2>
            </div>
            <div className='row text-center' style={{width:'80%', margin:'auto'}}>
                <p className='text-center pull-down-xs-2'>We appreciate your feedback! Please let us know why you are declining the work performed.</p>
            </div>
            <div className='row text-center' style={{width:'70%', margin:'auto'}}>
                <FormGroup className='pull-down-xs-2'validationState={this.state.topicValidState}>
                    <FormControl componentClass='select' className='faq-group' id='rejectReason' placeholder='select'>
                        <option value="default" disabled selected>Select reason for decline</option>
                        <option value='POOR_QUALITY'>Poor Quality</option>
                        <option value='NO_WORK_PERFORMED'>No Work Performed</option>
                        <option value='PARTIAL_WORK_COMPLETED'>Partial Work Completed</option>
                        <option value='PROPERTY_DAMAGE'>Property Damage</option>
                        <option value='OTHER'>Other</option>
                    </FormControl>
                </FormGroup>
              </div>
              <div className='row text-center' style={{width:'90%', margin:'auto'}}>
                  <p className='pull-down-xs-4'>Add any additional details:</p>
              </div>
              <div className='row' style={{width:'90%', margin:'auto'}}>
                <FormGroup className='center-block pull-down-xs-1' style={{width:'85%'}}>
                    <FormControl className='faq-text' componentClass='textarea' name='rejectionComment' id='rejectionComment' value={this.state.rejectionComment} onChange={this.handleInputChange} style={{height: 111, paddingTop: 20}}/>
                </FormGroup>
              </div>
            <div className='text-center pull-down-xs-2'>
            <button className='btn btn-success' onClick={this.sendUpdateToServer}>Decline</button>
            </div>
            <div className='text-center pull-down-xs-1' style={{marginBottom: 30}}>
                <a style={{textDecoration:'underline'}} onClick={this.returnModal}>Go back</a>
            </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/decline-task-modal.jsx